import {MOON_100} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ButtonPanel = styled.div`
  visibility: hidden;
`;
ButtonPanel.displayName = 'S.ButtonPanel';

export const MainPanel = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  &:hover {
    background-color: ${MOON_100};
    ${ButtonPanel} {
      visibility: visible;
    }
  }
`;
MainPanel.displayName = 'S.MainPanel';

export const ContentPanel = styled.div`
  flex: 1 1 auto;
`;
ContentPanel.displayName = 'S.ContentPanel';
